export default __webpack_public_path__ + "static/media/generalMain1.8c7f9776.png";